if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Add metafield properties for delivery time calculation
const lieferzeitField = this.form.querySelector('.product-variant-lieferzeit');
const lagerField = this.form.querySelector('.product-variant-lager');
const lagerTypField = this.form.querySelector('.product-variant-lager-typ');

if (lieferzeitField && lieferzeitField.value) formData.append('properties[lieferzeit]', lieferzeitField.value);
if (lagerField && lagerField.value) formData.append('properties[lager]', lagerField.value);
if (lagerTypField && lagerTypField.value) formData.append('properties[lager_typ]', lagerTypField.value);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            // Lieferzeit-Attribut sofort nach cart/add setzen (fuer PayPal Express / Shop Pay)
            // Berechnet die LAENGSTE Lieferzeit aller Artikel im Warenkorb
            (function() {
              try {
                function addWeekdays(date, days) {
                  var result = new Date(date);
                  var added = 0;
                  while (added < days) {
                    result.setDate(result.getDate() + 1);
                    var day = result.getDay();
                    if (day !== 0 && day !== 6) added++;
                  }
                  return result;
                }
                function formatDate(date) {
                  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
                }
                // Cart-Daten und Delivery-Times laden
                Promise.all([
                  fetch('/cart.js').then(function(r) { return r.json(); }),
                  fetch('/cart/items.json').then(function(r) { return r.json(); }).catch(function() { return null; })
                ]).then(function(results) {
                  var cart = results[0];
                  // variant-delivery-times Script-Tag lesen (enthaelt Lager/Lieferzeit-Daten)
                  var deliveryDataTag = document.getElementById('variant-delivery-times');
                  var deliveryData = [];
                  if (deliveryDataTag) {
                    try { deliveryData = JSON.parse(deliveryDataTag.textContent); } catch(e) {}
                  }
                  var maxLieferzeit = 0;
                  if (cart && cart.items && cart.items.length > 0) {
                    cart.items.forEach(function(item) {
                      var variantId = item.variant_id;
                      var qty = item.quantity || 1;
                      var entry = deliveryData.find(function(e) { return e.id == variantId; });
                      if (entry) {
                        var stock = parseInt(entry.lager) || 0;
                        var time = parseInt(entry.delivery_time) || 0;
                        if (qty > stock || time === 0) maxLieferzeit = Math.max(maxLieferzeit, 7);
                        else maxLieferzeit = Math.max(maxLieferzeit, time);
                      } else {
                        // Artikel nicht in delivery-times: sicherheitshalber laengste Zeit nehmen
                        maxLieferzeit = Math.max(maxLieferzeit, 7);
                      }
                    });
                  } else {
                    // Fallback: Lieferzeit-Badge des aktuellen Produkts lesen
                    var badge = document.getElementById('delivery-time-display');
                    if (badge) {
                      var badgeText = badge.textContent
                        .replace('📦 Lieferung zwischen ', '')
                        .replace(' innerhalb DE', '')
                        .trim();
                      if (badgeText) {
                        fetch(routes.cart_update_url, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                          body: JSON.stringify({ attributes: { 'Lieferzeit': badgeText } })
                        }).catch(function(e) { console.warn('Lieferzeit Fehler:', e); });
                      }
                    }
                    return;
                  }
                  var deliveryText = '';
                  if (maxLieferzeit > 0) {
                    var today = new Date();
                    var fromDate, toDate;
                    if (maxLieferzeit <= 3) {
                      fromDate = addWeekdays(today, 1);
                      toDate = addWeekdays(today, 3);
                    } else {
                      fromDate = addWeekdays(today, 7);
                      toDate = addWeekdays(today, 10);
                    }
                    deliveryText = formatDate(fromDate) + ' – ' + formatDate(toDate);
                  }
                  if (deliveryText) {
                    fetch(routes.cart_update_url, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ attributes: { 'Lieferzeit': deliveryText } })
                    }).catch(function(e) { console.warn('Lieferzeit Fehler:', e); });
                  }
                }).catch(function(e) { console.warn('Lieferzeit Multi-Artikel Fehler:', e); });
              } catch(e) { console.warn('Lieferzeit-Attribut Fehler:', e); }
            })();
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
